module.exports = __webpack_public_path__ + "img/logo.203fc777.svg";